import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAppSelector } from '~/common/stores';
import { getAccessToken } from '~/features/auth/utils/auth.util';

/**
 * 라우트 레벨 인증 가드
 * - CheckAuth 이후에 동작
 * - 인증되지 않은 사용자를 로그인 페이지로 리다이렉트
 * - routes에서 부모 라우트에 적용하여 하위 라우트 보호
 */
function AuthGuard() {
  const location = useLocation();
  const { isLoading, authUser } = useAppSelector(state => state.auth);
  const accessToken = getAccessToken();

  // 인증 상태 확인 중이면 아무것도 렌더링하지 않음
  if (isLoading) {
    return null;
  }

  // 토큰이 없거나 사용자 정보가 없으면 로그인 페이지로
  if (!accessToken || !authUser) {
    const redirectPath = `/auth/signin?next=${location.pathname}`;
    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
}

export default AuthGuard;
